import React from 'react';
import logo from '../assets/images/logo.png';
import c12_1 from '../assets/images/c12_1.png';
import c12_2 from '../assets/images/c12_2.png';
import c12_3 from '../assets/images/c12_3.png';
import c12_4 from '../assets/images/c12_4.png';
import c12_5 from '../assets/images/c12_5.png';
import c12_6 from '../assets/images/c12_6.png';
import c12_7 from '../assets/images/c12_7.png';
import c12_8 from '../assets/images/c12_8.png';
import c12_9 from '../assets/images/c12_9.png';
import c12_10 from '../assets/images/c12_10.png';
import f0_1 from '../assets/images/f0_1.png';
import f0_2 from '../assets/images/f0_2.png';
import f0_3 from '../assets/images/f0_3.png';
import f0_4 from '../assets/images/f0_4.png';
import qrcode from '../assets/images/qrcode.png';
import f01_1 from '../assets/images/f01_1.png';
import f01_2 from '../assets/images/f01_2.png';
import f01_3 from '../assets/images/f01_3.png';
import f01_4 from '../assets/images/f01_4.png';
import content132 from '../assets/images/content132.png';
import f8 from '../assets/images/feature8.png';
import arrow from '../assets/images/arrow.png';


export const Nav21DataSource = {
  isScrollLink: true,
  wrapper: { className: 'header2 home-page-wrapper m7a420omjnt-editor_css' },
  page: { className: 'home-page' },
  logo: {
    className: 'header2-logo',
    children: logo,
  },
  LinkMenu: {
    className: 'header2-menu',
    children: [
      {
        name: 'linkNav',
        to: 'Banner1_0',
        children: '首页',
        className: 'menu-item m7a3zvycs7d-editor_css',
      },
      {
        name: 'linkNav~m7a442uitu7',
        to: 'Content13_0',
        children: '产品与解决方案',
        className: 'menu-item m7a3zvycs7d-editor_css',
      },
      {
        name: 'linkNav~m7a443ceui',
        to: 'Content5_1',
        children: '成功案例',
        className: 'menu-item m7a3zvycs7d-editor_css',
      },
      {
        name: 'linkNav~m7a443rqsve',
        to: 'Content12_0',
        children: '合作伙伴',
        className: 'menu-item m7a3zvycs7d-editor_css',
      },
      {
        name: 'linkNav~m7a444o6l4',
        to: 'Feature0_0',
        children: '关于我们',
        className: 'menu-item m7a3zvycs7d-editor_css',
      },
    ],
  },
  mobileMenu: { className: 'header2-mobile-menu' },
};
export const Banner10DataSource = {
  wrapper: { className: 'banner1' },
  BannerAnim: {
    children: [
      {
        name: 'elem0',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: {
          className: 'banner1-text-wrapper m78sahxyopq-editor_css',
        },
        bg: { className: 'bg bg0 m78rfc45e89-editor_css' },
        title: {
          className: 'banner1-title',
          children:
            'https://zos.alipayobjects.com/rmsportal/HqnZZjBjWRbjyMr.png',
        },
        content: {
          className: 'banner1-content',
          children: '一个高效的页面动画解决方案',
        },
        button: { className: 'banner1-button', children: 'Learn More' },
      },
      {
        name: 'elem1',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1' },
        title: {
          className: 'banner1-title',
          children:
            'https://zos.alipayobjects.com/rmsportal/HqnZZjBjWRbjyMr.png',
        },
        content: {
          className: 'banner1-content',
          children: '一个高效的页面动画解决方案',
        },
        button: { className: 'banner1-button', children: 'Learn More' },
      },
      {
        name: 'elem2',
        BannerElement: { className: 'banner-user-elem' },
        textWrapper: { className: 'banner1-text-wrapper' },
        bg: { className: 'bg bg1' },
        title: {
          className: 'banner1-title',
          children:
            'https://zos.alipayobjects.com/rmsportal/HqnZZjBjWRbjyMr.png',
        },
        content: {
          className: 'banner1-content',
          children: '一个高效的页面动画解决方案',
        },
        button: { className: 'banner1-button', children: 'Learn More' },
      },
    ],
  },
};
export const Content130DataSource = {
  OverPack: {
    className: 'home-page-wrapper content13-wrapper m78uaub5j-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>AIYI AIOT赋能千行百业 激活企业数字化新引擎</p>
          </span>
        ),
        className: 'title-h1 m78ub0pdcf-editor_css',
      },
      {
        name: 'content',
        children: (
          <span>
            <p>
              基于云-管-边-端的AIOT平台+数据中台，全链路全生命周期数据互联互通，赋能工业互联PAAS能力，聚焦SAAS层丰富度
            </p>
          </span>
        ),
        className: 'title-content m78ub4vakg-editor_css',
      },
    ],
  },
};
export const Content51DataSource = {
  wrapper: {
    className: 'home-page-wrapper content5-wrapper m78ul3bybn-editor_css',
  },
  page: { className: 'home-page content5' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper m78svam41ir-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>数字孪生可视化 加速全场景数字化</p>
          </span>
        ),
        className: 'title-h1 m7a58w75bt-editor_css',
      },
    ],
  },
  block: {
    className: 'content5-img-wrapper',
    gutter: 16,
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
          },
          content: { children: 'Ant Design' },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
          },
          content: { children: 'Ant Motion' },
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
          },
          content: { children: 'Ant Design' },
        },
      },
      {
        name: 'block3',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
          },
          content: { children: 'Ant Motion' },
        },
      },
      {
        name: 'block4',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
          },
          content: { children: 'Ant Design' },
        },
      },
      {
        name: 'block5',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
          },
          content: { children: 'Ant Motion' },
        },
      },
      {
        name: 'block6',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://t.alipayobjects.com/images/rmsweb/T11aVgXc4eXXXXXXXX.svg',
          },
          content: { children: 'Ant Design' },
        },
      },
      {
        name: 'block7',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'content5-block-content' },
          img: {
            children:
              'https://zos.alipayobjects.com/rmsportal/faKjZtrmIbwJvVR.svg',
          },
          content: { children: 'Ant Motion' },
        },
      },
    ],
  },
};

export const Feature70DataSource = {
  wrapper: { className: 'home-page-wrapper feature7-wrapper' },
  page: { className: 'home-page feature7' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature7-title-wrapper',
    children: [
      {
        name: 'title',
        className: 'feature7-title-h1',
        children: '产品优势',
      },
      {
        name: 'content',
        className: 'feature7-title-content',
        children: '相比于其他产品服务商，我们自研产品覆盖了从硬件到软件、从设备端、边缘端到云端全业务的物联网与管理应用需求，帮助客户快速构建物联网能力，实现数字化、智能化管理升级。',
      },
    ],
  },
  blockWrapper: {
    className: 'feature7-block-wrapper',
    gutter: 24,
    children: [
      {
        md: 6,
        xs: 24,
        name: 'block0',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'index',
              className: 'feature7-block-index',
              children: '01',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '边缘计算网关',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '提供强悍的数据采集能力，同时支持大量设备驱动:Modbus、OPC UA.SNMP、 MOTT..',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block1',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'index',
              className: 'feature7-block-index',
              children: '02',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '物联网与数据中台',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '向下收集网关数据，进行清洗和汇总，向上提供开放接口，为业务系统提供设备数据..',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block2',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'index',
              className: 'feature7-block-index',
              children: '03',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '低代码应用开发平台',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '快速搭建契合公司业务流程的应用，并结合设备数据对生产流程服务运营进行深度整..',
            },
          ],
        },
      },
      {
        md: 6,
        xs: 24,
        name: 'block3',
        className: 'feature7-block',
        children: {
          className: 'feature7-block-group',
          children: [
            {
              name: 'index',
              className: 'feature7-block-index',
              children: '04',
            },
            {
              name: 'title',
              className: 'feature7-block-title',
              children: '数字孪生可视化系统',
            },
            {
              name: 'content',
              className: 'feature7-block-content',
              children: '通过设备与应用数据打造可视化报表，提供直观的交互操作，进一步挖掘数据价值..',
            },
          ],
        },
      }
    ],
  },
};
export const Content120DataSource = {
  wrapper: {
    className: 'home-page-wrapper content12-wrapper m78t3py12m-editor_css',
  },
  page: { className: 'home-page content12 m79uk84sn7n-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper m78t2730opq-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>携手行业龙头企业，跨行业领域赋能</p>
          </span>
        ),
        className: 'title-h1 m78t1b4vpn-editor_css',
      },
      {
        name: 'title~m78t1cewfh7',
        className: 'm78t1vtkbxd-editor_css',
        children: (
          <span>
            <p>10000+</p>
          </span>
        ),
      },
    ],
  },
  block: {
    className: 'img-wrapper m78t51fu3hm-editor_css',
    children: [
      {
        name: 'block0',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_1,
          },
        },
      },
      {
        name: 'block1',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_2,
          },
        },
      },
      {
        name: 'block2',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_3,
            className: 'm78t4y9rr1a-editor_css',
          },
        },
      },
      {
        name: 'block3',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_4,
          },
        },
      },
      {
        name: 'block4',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_5,
          },
        },
      },
      {
        name: 'block5',
        className: 'block m78tcccivoc-editor_css',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_6,
          },
        },
      },
      {
        name: 'block~m78t5legp6u',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_7,
          },
        },
      },
      {
        name: 'block~m78t5nl8s2m',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_8,
          },
        },
      },
      {
        name: 'block~m78t5o49pxq',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_9,
          },
        },
      },
      {
        name: 'block~m78t5ozi3ol',
        className: 'block',
        md: 6,
        xs: 24,
        children: {
          wrapper: { className: 'block-content' },
          img: {
            children: c12_10,
          },
        },
      }
    ],
    gutter: 0,
  },
};
export const Feature00DataSource = {
  wrapper: {
    className: 'home-page-wrapper content0-wrapper m7a37hsegoj-editor_css',
  },
  page: { className: 'home-page content0 m7a2y3lu0f-editor_css' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper m7a2t1haea-editor_css',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>关于我们</p>
          </span>
        ),
        className: 'm7a36lqi28-editor_css',
      },
      {
        name: 'content~m7a2sviqz4d',
        className: 'm7a351oypb9-editor_css',
        children: (
          <span>
            <p>
              相比于其他产品服务商，我们自研产品覆盖了从硬件到软件、从设备端、边缘端到云端全业务的物联网与管理应用需求，帮助客户快速构建物联网能力，实现数字化、智能化管理升级。
            </p>
          </span>
        ),
      },
      {
        name: 'content~m7a2zpax3lf',
        className: 'm7a364bvgta-editor_css',
        children: (
          <span>
            <p>
              TAIYI
              AIOT工业互联网PaaS平台：包括了自研的边缘计算网关嵌入式系统、物联网中台、数据中台、低代码应用开发平台和数字孪生可视化平台五大模块。{' '}
            </p>
          </span>
        ),
      },
      {
        name: 'content~m7a2zppmsf9',
        className: 'm7a369jeer-editor_css',
        children: (
          <span>
            <p>
              技术优势：“一套平台、五套工具、数据拉通、无缝集成”，提供一体化端到端的产品化技术底座，大幅减少在项目交付和产品研发方面的周期和成本。
            </p>
          </span>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content0-block-wrapper m7a2tj20hpk-editor_css',
    gutter: [16, 16],
    children: [
      {
        name: 'block0',
        className: 'content0-block m7a2twnpstt-editor_css',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: f0_1,
            },
            {
              name: 'title',
              className: 'content0-block-title m7a2ueepqlg-editor_css',
              children: (
                <span>
                  <p>一套平台</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content0-block m7a2tsz9cpu-editor_css',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: f0_2,
            },
            {
              name: 'title',
              className: 'content0-block-title m7a2ucin2h8-editor_css',
              children: (
                <span>
                  <p>五套工具</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content0-block m7a2t8383z-editor_css',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: f0_3,
            },
            {
              name: 'title',
              className: 'content0-block-title m7a2uami8kt-editor_css',
              children: (
                <span>
                  <p>数据拉通</p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~m7a2tcx6ojq',
        className: 'content0-block m7a2tzodinf-editor_css',
        md: 6,
        xs: 24,
        children: {
          className: 'content0-block-item',
          children: [
            {
              name: 'image',
              className: 'content0-block-icon',
              children: f0_4,
            },
            {
              name: 'title',
              className: 'content0-block-title m7a2u35h9lu-editor_css',
              children: (
                <span>
                  <p>无缝集成</p>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Content131DataSource = {
  OverPack: {
    className: 'home-page-wrapper content131-wrapper m7mrpe390m-editor_css',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>智慧矿山</p>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        children: (
          <p>
            以数字孪生为核心、数据整合为基础，基于统一的数字空间，形成集可视化高度融合的生产指挥调度平台、高可靠安全监测及设备保障平台、高效率信息化管理平台为一体的『流程贯通、业务融合、场景监控』的智慧矿山操作系统。
          </p>
        ),
        className: 'title-content',
      },
    ],
  },
};
export const Feature01DataSource = {
  wrapper: { className: 'home-page-wrapper content01-wrapper' },
  page: { className: 'home-page content01' },
  OverPack: { playScale: 0.3, className: '' },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>行业痛点</p>
          </span>
        ),
      },
      {
        name: 'content',
        children: (
          <p>以数字孪生为核心、数据整合为基础，基于统一的数字空间，形成集可视化高度融合的生产指挥调度平台、高可靠安全监测及设备保障平台、高效率信息化管理平台为一体的『流程贯通、业务融合、场景监控』的智慧矿山操作系统。</p>
        ),
      },
    ],
  },
  childWrapper: {
    className: 'content01-block-wrapper',
    children: [
      {
        name: 'block0',
        className: 'content01-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content01-block-item',
          children: [
            {
              name: 'image',
              className: 'content01-block-icon',
              children: f01_1,
            },
            {
              name: 'title',
              className: 'content01-block-title',
              children: (
                <span>
                  <p>数据缺乏应用</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>
                    硬件设备及各业务系统产生的海量数据没有得到深层次的应用，只是简单的文字堆砌
                  </p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block1',
        className: 'content01-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content01-block-item',
          children: [
            {
              name: 'image',
              className: 'content01-block-icon',
              children: f01_2,
            },
            {
              name: 'title',
              className: 'content01-block-title',
              children: (
                <span>
                  <p>应用缺乏融合</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>
                    大多数矿山仍以专业为界线分别研究、开发、配置软硬件系统，造成信息无法共享交流、系统操作复杂、应用孤岛严重
                  </p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block2',
        className: 'content01-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content01-block-item',
          children: [
            {
              name: 'image',
              className: 'content01-block-icon',
              children: f01_3,
            },
            {
              name: 'title',
              className: 'content01-block-title',
              children: (
                <span>
                  <p>管理缺乏协同</p>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>
                    随着业务的横向打通，各横向业务部门之间的业务协同缺乏网络化和分布式协同平台，管理难度大
                  </p>
                </span>
              ),
            },
          ],
        },
      },
      {
        name: 'block~m7ms3c2a7dh',
        className: 'content01-block',
        md: 6,
        xs: 24,
        children: {
          className: 'content01-block-item',
          children: [
            {
              name: 'image',
              className: 'content01-block-icon',
              children: f01_4,
            },
            {
              name: 'title',
              className: 'content01-block-title',
              children: (
                <span>
                  <span>
                    <p>决策缺乏依据</p>
                  </span>
                </span>
              ),
            },
            {
              name: 'content',
              children: (
                <span>
                  <p>
                    硬件设备及各业务系统产生的海量数据没有得到深层次的应用，只是简单的文字堆砌
                  </p>
                </span>
              ),
            },
          ],
        },
      },
    ],
  },
};
export const Content132DataSource = {
  OverPack: {
    className: 'home-page-wrapper content132-wrapper',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>建设目标</p>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        children: (
          <span>
            <p>
              平台整合矿山设备和矿山子系统数据，实现矿山数据的实时监控，生产过程的安全预测。利用大数据分析结合AI算法，推动AI技术与矿山应用系统的适配，提升矿山应用智能化水平。
            </p>
          </span>
        ),
        className: 'title-content',
      },
      {
        name: 'list',
        className: 'list-wrapper',
        children: (
          <ul>
            <li>结构沉降监测</li>
            <li>敏感气体监控</li>
            <li>进出门禁监控</li>
            <li>照明监控</li>
            <li>消防监控</li>
            <li>机器人监控</li>
            <li>风机监控</li>
            <li>排水监控</li>
            <li>视频监控</li>
            <li>人员定位</li>
            <li>...</li>
          </ul>
        ),
      },
      {
        name: 'image~m7mrxfggilj',
        className: '',
        children: content132,
      },
    ],
  },
};
export const Content133DataSource = {
  OverPack: {
    className: 'home-page-wrapper content133-wrapper',
    playScale: 0.3,
  },
  titleWrapper: {
    className: 'title-wrapper',
    children: [
      {
        name: 'title',
        children: (
          <span>
            <p>整体系统架构设计</p>
          </span>
        ),
        className: 'title-h1',
      },
      {
        name: 'content',
        children: (
          <span>
            <p>
              平台整合矿山设备和矿山子系统数据，实现矿山数据的实时监控，生产过程的安全预测。利用大数据分析结合AI算法，推动AI技术与矿山应用系统的适配，提升矿山应用智能化水平。
            </p>
          </span>
        ),
        className: 'title-content',
      },
    ],
  },
};
export const Footer10DataSource = {
  wrapper: { className: 'home-page-wrapper footer1-wrapper' },
  OverPack: { className: 'footer1', playScale: 0.2 },
  block: {
    className: 'home-page m78qrglqqwj-editor_css',
    gutter: 0,
    children: [
      {
        name: 'block0',
        xs: 24,
        md: 4,
        className: 'block',
        title: {
          className: 'logo',
          children: logo,
        },
        childWrapper: {
          className: 'slogan',
          children: [
            {
              name: 'content0',
              children: '广州和弘信息科技有限公司',
            },
            {
              name: 'image',
              children: qrcode,
            },
            {
              name: 'content1',
              children: '更多解决方案',
            },
          ],
        },
      },
      {
        name: 'block1',
        xs: 24,
        md: 4,
        className: 'block m78uq2mvmv-editor_css',
        title: { children: '产品', className: 'm78uzv1a6bt-editor_css' },
        childWrapper: {
          children: [
            { name: 'link0', href: '#', children: '产品更新记录' },
            { name: 'link1', href: '#', children: 'API文档'},
            { name: 'link2', href: '#', children: '快速入门' },
            { name: 'link3', href: '#', children: '参考指南' },
          ],
          className: 'm78uzqr8zrg-editor_css',
        },
      },
      {
        name: 'block2',
        xs: 24,
        md: 4,
        className: 'block m78uq7e89s-editor_css',
        title: {
          children: '解决方案',
          className: 'm78qmbnms4t-editor_css',
        },
        childWrapper: {
          children: [
            { href: '#', name: 'link0', children: 'FAQ' },
            { href: '#', name: 'link1', children: '联系我们' },
          ],
        },
      },
      {
        name: 'block3',
        xs: 24,
        md: 4,
        className: 'block m78uqekgkjr-editor_css',
        title: {
          children: '服务与解决方案',
          className: 'm78qmxsh5su-editor_css',
        },
        childWrapper: {
          children: [
            { name: 'link0', href: '#', children: '产品更新记录' },
            { name: 'link1', href: '#', children: 'API文档'},
            { name: 'link2', href: '#', children: '快速入门' },
            { name: 'link3', href: '#', children: '参考指南' },
          ],
        },
      },
      {
        name: 'block~m78qhsdve1b',
        xs: 24,
        md: 4,
        className: 'block m78uqxwg5gi-editor_css',
        title: {
          children: '关于我们',
          className: 'm78qqnegm8-editor_css',
        },
        childWrapper: {
          children: [
            { name: 'link0', href: '#', children: '产品更新记录' },
            { name: 'link1', href: '#', children: 'API文档'},
            { name: 'link2', href: '#', children: '快速入门' },
            { name: 'link3', href: '#', children: '参考指南' },
          ],
        },
      },
      {
        name: 'block~m78uycyrxuh',
        xs: 24,
        md: 4,
        className: 'block',
        title: {
          className: 'logo',
          children:
            '联系方式',
        },
        childWrapper: {
          children: [
            { name: 'content0', children: '18903062227' },
            { name: 'content1', children: '赵先生'},
            { name: 'content2', children: '市场合作' },
            { name: 'content3', children: '108835756@qq.com' },
            { name: 'content4', children: '联系地址' },
            { name: 'content5', children: '广州市黄埔区凝彩路26号(自编六栋)406/408房' },
          ],
        },
      },
    ],
  },
  copyrightWrapper: { className: 'copyright-wrapper' },
  copyrightPage: { className: 'home-page' },
  copyright: {
    className: 'copyright',
    children: (
      <span>
        ©2022 by 和弘科技 All Rights Reserved <a href="https://beian.miit.gov.cn" style={{ marginLeft: '10px' }}>粤ICP备19031657号</a>
      </span>
    ),
  },
};
export const Feature80DataSource = {
  wrapper: { className: 'home-page-wrapper feature8-wrapper' },
  page: { className: 'home-page feature8' },
  OverPack: { playScale: 0.3 },
  titleWrapper: {
    className: 'feature8-title-wrapper',
    children: [
      { name: 'title', className: 'feature8-title-h1', children: '应用价值' },
      {
        name: 'content',
        className: 'feature8-title-content',
        children: '通过“智能化+一体化”的管理与技术手段，实现矿山从实体到数字的价值提升。',
      },
      {
        name: 'image~m7son9mb04r',
        className: 'feature8-title-image',
        children: f8,
      },
    ],
  },
  childWrapper: {
    className: 'feature8-button-wrapper',
    children: [
      {
        name: 'content~m7sonjolh5m',
        className: '',
        children: (
          <span>
            <br />
          </span>
        ),
      },
    ],
  },
  Carousel: {
    dots: false,
    className: 'feature8-carousel',
    wrapper: { className: 'feature8-block-wrapper' },
    children: {
      className: 'feature8-block',
      titleWrapper: {
        className: 'feature8-carousel-title-wrapper',
        title: { className: 'feature8-carousel-title' },
      },
      children: [
        {
          name: 'block0',
          className: 'feature8-block-row',
          gutter: 120,
          title: {
            className: 'feature8-carousel-title-block',
            children: '平台自主训练流程',
          },
          children: [
            {
              className: 'feature8-block-col',
              md: 6,
              xs: 24,
              name: 'child0',
              arrow: {
                className: 'feature8-block-arrow',
                children: arrow,
              },
              children: {
                className: 'feature8-block-child',
                children: [
                  {
                    name: 'title',
                    className: 'feature8-block-title',
                    children: (
                      <div>
                        <span>
                          01
                        </span>
                        <p>
                          调研分析
                        </p>
                      </div>
                    ),
                  },
                  {
                    name: 'content',
                    className: 'feature8-block-content',
                    children: (
                      <ul>
                        <li>项目前期调研，可行性研究分析。</li>
                        <li>与业主交流，进行项目需求分析设计。</li>
                      </ul>
                    ),
                  },
                ],
              },
            },
            {
              className: 'feature8-block-col',
              md: 6,
              xs: 24,
              name: 'child1',
              arrow: {
                className: 'feature8-block-arrow',
                children: arrow,
              },
              children: {
                className: 'feature8-block-child',
                children: [
                  {
                    name: 'title',
                    className: 'feature8-block-title',
                    children: (
                      <div>
                        <span>
                          02
                        </span>
                        <p>
                          规划设计
                        </p>
                      </div>
                    ),
                  },
                  {
                    name: 'content',
                    className: 'feature8-block-content',
                    children: (
                      <ul>
                        <li>进行项目规划设计。</li>
                        <li>矿山图纸自控工程详细设计。</li>
                        <li>编制矿山实施建设方案。</li>
                      </ul>
                    ),
                  },
                ],
              },
            },
            {
              className: 'feature8-block-col',
              md: 6,
              xs: 24,
              name: 'child2',
              arrow: {
                className: 'feature8-block-arrow',
                children: arrow,
              },
              children: {
                className: 'feature8-block-child',
                children: [
                  {
                    name: 'title',
                    className: 'feature8-block-title',
                    children: (
                      <div>
                        <span>
                          03
                        </span>
                        <p>
                          项目建设
                        </p>
                      </div>
                    ),
                  },
                  {
                    name: 'content',
                    className: 'feature8-block-content',
                    children: (
                      <ul>
                        <li>矿山施工建设。·</li>
                        <li>智慧矿山信息化系统软硬件开发及建设。</li>
                      </ul>
                    ),
                  },
                ],
              },
            },
            {
              className: 'feature8-block-col',
              md: 6,
              xs: 24,
              name: 'child3',
              arrow: {
                className: 'feature8-block-arrow',
                children: arrow,
              },
              children: {
                className: 'feature8-block-child',
                children: [
                  {
                    name: 'title',
                    className: 'feature8-block-title',
                    children: (
                      <div>
                        <span>
                          04
                        </span>
                        <p>
                          运营维护
                        </p>
                      </div>
                    ),
                  },
                  {
                    name: 'content',
                    className: 'feature8-block-content',
                    children: (
                      <ul>
                        <li>运营期间，进行矿山日常运维管理。</li>
                        <li>提供矿山运维管理状况评估报告。</li>
                      </ul>
                    ),
                  },
                ],
              },
            },
          ],
        },
      ],
    },
  },
};